<script setup lang="ts">
import { useAuthStore } from '@/stores/authStore'

defineProps<{
  title: string
  subtitle: string
}>()

const authStore = useAuthStore()
const user = authStore.user
</script>

<template>
  <div class="q-pb-md">
    <header class="row justify-between items-center q-py-sm">
      <div class="row items-center q-gutter-x-sm">
        <div class="column">
          <p class="text-h6 no-margin">{{ title }}</p>
          <p class="text-caption no-margin">{{ subtitle }}</p>
        </div>
        <div>
          <slot name="title-actions" />
        </div>
      </div>
      <div class="row items-center q-gutter-x-sm">
        <slot name="actions" />
        <q-avatar v-if="user" size="40px">
          <q-img alt="Profile picture" :src="user.picture">
            <template v-slot:error>
              <q-icon name="mdi-account" size="sm" />
            </template>
          </q-img>
        </q-avatar>
      </div>
    </header>
    <q-separator style="width: calc(100vw - 70px); position: relative; left: 50%; transform: translateX(-50%)" />
  </div>
</template>
